<template>
  <!--  <div class="page-wrap">-->
  <div class="">
    <!--      <m-header title="系统通知" left-link="/m/user/index" @closeLang="getList"></m-header>-->
    <!--    type="border-card"-->
    <i v-if="noticeId" class="el-icon-back ft-20" @click="noticeId = null" />
    <messageForm v-if="noticeId" :id="noticeId" />
    <div v-else class="list">
      <el-tabs v-model="type" @tab-click="getList">
        <el-tab-pane :label="$t('站内信')" name="MESSAGE" />
        <el-tab-pane :label="$t('系统通知')" name="NEWS" />
      </el-tabs>
      <div class="box-container">
        <van-empty v-if="!list || list.length === 0" :description="$t(`没有更多数据`)" />
        <div v-else>

          <div class="box-list">
            <div v-for="(item,index) in list" :key="index" class="box-item u-p-8">
              <div class="d-flex justify-around align-center">
                <iconLetter class="mr-2" :is-read="item.isRead" @click.native="()=>{noticeId = null;item.isRead=true;$nextTick(() => {noticeId = item.id})}" />
                <div class="u-m-l-10 flex-full">
                  <div class="bold ft-16 mb-1" @click="()=>{noticeId = null;item.isRead=true;$nextTick(() => {noticeId = item.id})}">{{ item.subTitle || $t(item.title) }}</div>
                  <div class="mb-1" v-if="item.content">{{ item.content }}</div>
                  <div>{{ item.publishTime || item.createTime}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  </div>-->
</template>

<script>
import messageForm from '@/views/user/messageForm.vue'
import iconLetter from '@/views/user/iconLetter.vue'
// import { getNoticeList } from '@/api/user'
import { getNoticeList } from '@/api/sys/info'

export default {
  name: 'messageList',
  components: {
    messageForm,
    iconLetter
  },
  data() {
    return {
      type: 'MESSAGE',
      noticeId: null,
      list: null
    }
  },
  watch: {
    // type(newValue) {
    // const query = this.$router.history.current.query
    // const path = this.$router.history.current.path
    // // 对象的拷贝
    // const newQuery = JSON.parse(JSON.stringify(query))
    // // 地址栏的参数值赋值
    // newQuery.type = newValue
    // this.$router.push({ path, query: newQuery })
    // }
  },
  created() {
    if(this.userInfo && this.userInfo.id){
      this.getList()
    }
    // this.type = this.$route.query.type || 'MESSAGE'
  },
  methods: {
    getList() {
      this.list = []
      getNoticeList(this.type).then(res => {
        this.list = res && res.data || []
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
